<template>
  <div>
    <!--  LINK EVENT --->
    <v-row no-gutters v-if="getEventType === 'LINK'">
      <v-col cols="12" class="mb-4">
        <TopicTitle
          class="mb-4"
          :title="$t('new-event.settings.highligh')"
          icon="mdi-auto-fix"
          :subtitle="$t('new-event.settings.highligh-description')"
        />
        <v-checkbox
          hide-details="auto"
          :label="$t('new-event.settings.inputs.highligh')"
          v-model="getEventSettingsData.emphasis"
        />
      </v-col>
      <v-col
        cols="6"
        class="d-flex flex-column justify-space-between h-100 pb-0"
      >
        <TopicTitle
          :title="$t('new-event.settings.publication')"
          icon="mdi-upload"
          :subtitle="$t('new-event.settings.publication-description')"
        />
        <BaseSelect
          v-model="getEventSettingsData.publication"
          :label="$t('new-event.settings.publication')"
          persistent-placeholder
          item-value="value"
          item-text="item"
          :items="publication"
          :menu-props="{ top: true }"
          hide-details
        />
      </v-col>
      <!-- <v-col cols="12" md="6" class="pr-4">
        <TopicTitle
          class="mb-0"
          :title="$t('new-event.settings.event-group')"
          icon="mdi-group"
          :subtitle="$t('new-event.settings.event-group-description')"
        />
        <v-checkbox
          :label="$t('new-event.settings.inputs.has-event-group')"
          v-if="isAdmin"
          v-model="getEventSettingsData.hasAgroupedEvents"
          hide-details
          dense
        />
        <v-checkbox
          hide-details
          :label="$t('new-event.settings.inputs.event-group')"
          v-if="isAdmin"
          v-model="getEventSettingsData.showAgroupedEventsOnElevenTickets"
          class="mb-4"
          :disabled="!getEventSettingsData.hasAgroupedEvents"
          dense
        />
        <BaseAutocomplete
          v-model="getEventSettingsData.agroupedEvents"
          :label="$t('new-event.settings.inputs.events-to-group')"
          :no-data-text="$t('registrations.users.no-events-found')"
          multiple
          chips
          deletable-chips
          clearable
          persistent-placeholder
          hide-details
          :items="allEvents"
          :loading="eventsLoading"
          item-text="descricao"
          item-value="idproduto"
          :menu-props="{ top: true, maxHeight: 200 }"
          :disabled="!getEventSettingsData.hasAgroupedEvents"
        />
      </v-col> -->
    </v-row>

    <!--  NORMAL EVENT --->
    <v-form @submit.prevent ref="form">
      <v-row v-if="getEventType !== 'LINK'">
        <v-col v-if="isAdmin">
          <TopicTitle
            :title="$t('new-event.settings.highligh')"
            icon="mdi-auto-fix"
            :subtitle="$t('new-event.settings.highligh-description')"
          />
          <div class="d-flex">
            <v-checkbox
              class="mt-0"
              hide-details="auto"
              :label="$t('new-event.settings.inputs.highligh')"
              v-model="getEventSettingsData.emphasis"
            />
          </div>
        </v-col>
        <v-col>
          <TopicTitle
            :title="$t('new-event.settings.bearer')"
            icon="mdi-account-switch"
            :subtitle="$t('new-event.settings.bearer-description')"
          />
          <div class="d-flex">
            <v-checkbox
              class="mt-0"
              hide-details="auto"
              :label="$t('new-event.settings.inputs.bearer')"
              v-model="getEventSettingsData.changeBearer"
            />
          </div>
        </v-col>
      </v-row>
      <v-row v-if="getEventType !== 'LINK'">
        <v-col sm="6" cols="12">
          <TopicTitle
            class="mb-4"
            :title="$t('new-event.settings.slug')"
            icon="mdi-link"
            :subtitle="$t('new-event.settings.slug-description')"
          />
          <BaseTextField
            persistent-hint
            :label="$t('new-event.settings.inputs.url')"
            :placeholder="$t('new-event.settings.placeholders.url')"
            persistent-placeholder
            v-model="getEventSettingsData.url"
            prefix="eleventickets.com/"
            :rules="[rules.required, rules.maxLengthSlug]"
            counter="65"
            maxlength="65"
          />
        </v-col>

        <v-col>
          <TopicTitle
            class="mb-4"
            :title="$t('new-event.settings.limit')"
            icon="mdi-ticket-confirmation-outline"
            :subtitle="$t('new-event.settings.limit-description')"
          />
          <BaseTextField
            :label="$t('new-event.settings.inputs.limit')"
            hide-spin-buttons
            :placeholder="$t('new-event.settings.placeholders.limit')"
            v-model="getEventSettingsData.limitPerCustomer"
            persistent-placeholder
            :rules="[rules.nonNegativeNumber]"
            :hint="$t('new-event.settings.zero-to-ilimit')"
            persistent-hint
            @wheel.prevent
            maxLength="7"
            @input="limitInput($event, 'limitPerCustomer')"
            @focus="$event.target.select()"
          />
        </v-col>
      </v-row>

      <v-row class="mb-4">
        <v-col sm="6" cols="12" v-if="isAdmin && getEventType !== 'LINK'">
          <TopicTitle
            :title="$t('new-event.settings.period-cancel')"
            icon="mdi-cash-remove"
            :subtitle="$t('new-event.settings.period-cancel-description')"
            class="mb-4"
          />
          <BaseSelect
            :items="cancellationPeriod"
            class="mb-6"
            :label="$t('new-event.settings.inputs.period-cancel')"
            persistent-placeholder
            item-value="value"
            item-text="item"
            v-model="getEventSettingsData.cancellationPeriod"
            :menu-props="{ top: true, maxHeight: 200 }"
          />
          <v-col
            class="pa-0 d-flex"
            v-if="getEventSettingsData.cancellationPeriod === 'custom'"
          >
            <BaseTextField
              :label="$t('new-event.settings.inputs.after-sale')"
              placeholder="0"
              persistent-placeholder
              class="mr-4 mt-4"
              @wheel.prevent
              hide-spin-buttons
              v-model="getEventSettingsData.cancellationDays"
              maxlength="7"
              @input="limitInput($event, 'cancellationPeriod')"
              @focus="$event.target.select()"
            />
            <BaseTextField
              :label="$t('new-event.settings.inputs.before-event')"
              placeholder="0"
              persistent-placeholder
              class="mt-4"
              @wheel.prevent
              hide-spin-buttons
              v-model="getEventSettingsData.cancellationHours"
              maxlength="7"
              @input="limitInput($event, 'cancellationPeriod')"
              @focus="$event.target.select()"
            />
          </v-col>
        </v-col>
        <v-col v-if="isAdmin && getEventType !== 'LINK'" cols="12" md="6">
          <TopicTitle
            class="mb-4"
            :title="$t('new-event.settings.digital-wallet')"
            icon="mdi-wallet-bifold"
            :subtitle="$t('new-event.settings.digital-wallet-description')"
          />
          <BaseSelect
            item-value="value"
            item-text="item"
            :items="balanceSettings"
            class="mb-4"
            :label="$t('new-event.settings.inputs.withdrawal')"
            v-model="getEventSettingsData.balanceSettings"
            persistent-placeholder
            hide-details
          />
          <BaseMoneyField
            class="mt-4"
            v-model="getEventSettingsData.balanceReleased"
            :label="$t('new-event.settings.inputs.balance')"
            persistent-placeholder
            :options="optionsPercent"
            :rules="[rules.maxLimit]"
            selectContent
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="getEventType !== 'LINK'" md="6" cols="12">
          <TopicTitle
            class="mb-4"
            :title="$t('new-event.settings.hidden-sale')"
            icon="mdi-link-lock"
            :subtitle="$t('new-event.settings.hidden-sale-description')"
          />
          <date-time-picker
            :label="$t('new-event.settings.inputs.date-show-event')"
            @formatted-date="viewTypeFormattedDate"
            :edit="getEventSettingsData.viewType"
          />
        </v-col>
        <v-col
          v-if="getEventType !== 'LINK'"
          class="d-flex flex-column justify-space-between h-100 pb-0"
        >
          <TopicTitle
            :title="$t('new-event.settings.publication')"
            icon="mdi-upload"
            :subtitle="$t('new-event.settings.publication-description')"
          />
          <BaseSelect
            v-model="getEventSettingsData.publication"
            :label="$t('new-event.settings.publication')"
            persistent-placeholder
            item-value="value"
            item-text="item"
            :items="publication"
            hide-details="auto"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="6"
          class="pb-0 mt-4"
          order="1"
          order-md="1"
          v-if="getEventType !== 'LINK'"
        >
          <TopicTitle
            :icon="'mdi-ticket-confirmation-outline'"
            :title="
              $t('new-event.ticket-management.tickets.modal.period-access')
            "
            :subtitle="$t('new-event.settings.period-access-description')"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="pb-0 mt-4"
          v-if="isAdmin && getEventType !== 'LINK'"
          order="3"
          order-md="2"
        >
          <TopicTitle
            :title="$t('new-event.settings.comission')"
            icon="mdi-cash-refund"
            :subtitle="$t('new-event.settings.comission-description')"
          />
        </v-col>

        <v-col
          cols="12"
          :md="isAdmin ? '6' : '12'"
          v-if="getEventType !== 'LINK'"
          class="pt-0"
          order="2"
          order-md="3"
        >
          <v-row align="center" no-gutters>
            <v-checkbox
              hide-details
              v-model="getEventSettingsData.applyAllAccessPeriods"
              class="mb-4"
              :label="$t('new-event.settings.inputs.apply-all')"
            />
            <v-tooltip bottom color="red">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="red"
                  v-bind="attrs"
                  v-on="on"
                  class="ml-2"
                  style="cursor: pointer"
                >
                  mdi-information
                </v-icon>
              </template>
              <span>{{ $t("new-event.settings.access-period-warn") }}</span>
            </v-tooltip>
          </v-row>

          <div v-if="getIsRecurringEvent">
            <BaseTextField
              :label="
                $t(
                  'new-event.ticket-management.tickets.modal.inputs.check-in-recurring'
                )
              "
              placeholder="0"
              type="number"
              v-model="getEventSettingsData.accessPeriodStart"
              class="mt-4"
              :rules="[rules.nonNegativeNumber]"
              hide-spin-buttons
              @wheel.prevent
              hide-details="auto"
              @focus="$event.target.select()"
            />
            <div class="mt-4">
              <BaseTextField
                :label="
                  $t(
                    'new-event.ticket-management.tickets.modal.inputs.check-out-recurring'
                  )
                "
                placeholder="0"
                type="number"
                v-model="getEventSettingsData.accessPeriodEnd"
                class="mt-4"
                :rules="[rules.nonNegativeNumber]"
                hide-spin-buttons
                @wheel.prevent
                hide-details="auto"
                @focus="$event.target.select()"
              />
            </div>
          </div>
          <div v-else>
            <DateTimePicker
              :label="
                $t('new-event.ticket-management.tickets.modal.inputs.check-in')
              "
              :edit="getEventSettingsData.accessPeriodStart"
              @formatted-date="accessPeriodStartFormattedDate"
            />
            <div class="mt-4">
              <DateTimePicker
                :label="
                  $t(
                    'new-event.ticket-management.tickets.modal.inputs.check-out'
                  )
                "
                :edit="getEventSettingsData.accessPeriodEnd"
                @formatted-date="accessPeriodEndFormattedDate"
              />
            </div>
          </div>
          <BaseTextField
            :label="
              $t('new-event.ticket-management.tickets.modal.inputs.use-limits')
            "
            :hint="
              $t('new-event.ticket-management.tickets.modal.hint-use-limits')
            "
            persistent-hint
            type="number"
            v-model="getEventSettingsData.accessQuantity"
            class="mt-4"
            :rules="[rules.nonNegativeNumber]"
            hide-spin-buttons
            @wheel.prevent
            hide-details="auto"
            @focus="$event.target.select()"
            @input="limitInput($event, 'accessQuantity')"
            maxlength="7"
          />
          <div class="d-flex">
            <v-checkbox
              :label="
                $t(
                  'new-event.ticket-management.tickets.modal.inputs.eleven-access'
                )
              "
              v-if="isAdmin"
              v-model="getEventSettingsData.hasElevenAccess"
              hide-details="auto"
              dense
            />
          </div>
          <div class="d-flex">
            <v-checkbox
              :label="
                $t('new-event.ticket-management.tickets.modal.inputs.facial')
              "
              v-if="isAdmin"
              v-model="getEventSettingsData.hasFacial"
              hide-details="auto"
              dense
            />
          </div>
        </v-col>
        <v-col
          md="6"
          cols="12"
          class="pt-0"
          v-if="isAdmin && getEventType !== 'LINK'"
          order="4"
          order-md="4"
        >
          <v-row align="center" no-gutters>
            <v-checkbox
              hide-details
              :label="$t('new-event.settings.inputs.apply-all')"
              v-model="getEventSettingsData.applyAllCommissions"
              class="mb-4"
            />
            <v-tooltip bottom color="red">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="red"
                  v-bind="attrs"
                  v-on="on"
                  class="ml-2"
                  style="cursor: pointer"
                >
                  mdi-information
                </v-icon>
              </template>
              <span>{{ $t("new-event.settings.commission-warn") }}</span>
            </v-tooltip>
          </v-row>
          <BaseSelect
            hide-details="auto"
            :items="commissionType"
            item-text="item"
            item-value="value"
            :label="`${$t('new-event.settings.inputs.comission')} WEB`"
            persistent-placeholder
            v-model="getEventSettingsData.commissionWeb"
          ></BaseSelect>
          <v-row class="mt-1">
            <v-col cols="12" md="6">
              <BaseSelect
                item-value="value"
                item-text="item"
                :items="typeTax"
                :label="`${$t('new-event.settings.inputs.type-tax')} WEB`"
                persistent-placeholder
                v-model="getEventSettingsData.typeTaxWeb"
              />
            </v-col>
            <v-col cols="12" md="6">
              <BaseMoneyField
                v-if="getEventSettingsData.typeTaxWeb === 'percent'"
                class="mb-4"
                v-model="getEventSettingsData.taxWeb"
                :label="`${$t('new-event.settings.inputs.type-tax')} (%)`"
                persistent-placeholder
                :options="optionsPercent"
                :rules="[rules.maxLimit]"
                selectContent
              />
              <BaseMoneyField
                v-else
                class="mb-4"
                v-model="getEventSettingsData.taxWeb"
                :label="`${$t('new-event.settings.inputs.tax')} (R$)`"
                persistent-placeholder
                :options="optionsCurrency"
                selectContent
              />
            </v-col>
          </v-row>
          <BaseMoneyField
            v-model="getEventSettingsData.minimumTax"
            :label="`${$t('new-event.settings.inputs.min-tax')} (R$)`"
            persistent-placeholder
            :options="optionsCurrency"
            class="mb-4"
            selectContent
          />

          <BaseSelect
            hide-details="auto"
            :items="commissionType"
            :label="`${$t('new-event.settings.inputs.comission')} POS`"
            persistent-placeholder
            item-text="item"
            item-value="value"
            v-model="getEventSettingsData.commissionPos"
          ></BaseSelect>
          <v-row class="mt-1">
            <v-col cols="12" md="6">
              <BaseSelect
                item-text="item"
                item-value="value"
                :items="typeTax"
                :label="`${$t('new-event.settings.inputs.type-tax')} POS`"
                persistent-placeholder
                v-model="getEventSettingsData.typeTaxPos"
              />
            </v-col>
            <v-col cols="12" md="6">
              <BaseMoneyField
                v-if="getEventSettingsData.typeTaxPos === 'percent'"
                v-model="getEventSettingsData.taxPos"
                :label="`${$t('new-event.settings.inputs.tax')} (%)`"
                persistent-placeholder
                :options="optionsPercent"
                :rules="[rules.maxLimit]"
                selectContent
              />
              <BaseMoneyField
                v-else
                v-model="getEventSettingsData.taxPos"
                :label="`${$t('new-event.settings.inputs.tax')} (R$)`"
                persistent-placeholder
                :options="optionsCurrency"
                selectContent
              />
            </v-col>
          </v-row>
          <v-col cols="12" class="pa-0 ma-0 mb-2 d-flex align-center">
            <v-checkbox
              hide-details
              :label="$t('new-event.settings.inputs.has-process-tax')"
              v-model="getEventSettingsData.hasProcessingTax"
              dense
            />
          </v-col>
          <v-col
            v-if="getEventSettingsData.hasProcessingTax"
            cols="12"
            class="pa-0 ma-0"
          >
            <BaseMoneyField
              :options="optionsCurrency"
              v-model="getEventSettingsData.processingTax"
              :label="`${$t('new-event.settings.inputs.has-process-tax')} (R$)`"
              persistent-placeholder
              selectContent
            />
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="getEventType !== 'LINK'" md="6" cols="12">
          <TopicTitle
            class="mb-4"
            :title="$t('new-event.ticket-management.tickets.title')"
            icon="mdi-ticket-confirmation-outline"
            :subtitle="$t('new-event.settings.sold-out-tickets-description')"
          />
          <v-checkbox
            v-model="getEventSettingsData.showSoldOutTickets"
            :label="$t('new-event.settings.inputs.show-sold-out-tickets')"
            class="mt-0"
          ></v-checkbox>
        </v-col>
        <v-col v-if="getEventType !== 'LINK'" md="6" cols="12">
          <TopicTitle
            class="mb-4"
            :title="$t('new-event.settings.voucher-code')"
            icon="mdi-ticket-confirmation-outline"
            :subtitle="$t('new-event.settings.voucher-code-description')"
          />
          <v-checkbox
            v-model="getEventSettingsData.showVoucherCode"
            :label="$t('new-event.settings.inputs.show-voucher-code')"
            class="mt-0"
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import TopicTitle from "../TopicTitle.vue";
import BaseTextField from "../forms/BaseTextField.vue";
import BaseSelect from "../forms/BaseSelect.vue";
import DateTimePicker from "../forms/DateTimePicker.vue";
import BaseMoneyField from "../forms/BaseMoneyField.vue";
// import BaseAutocomplete from "../forms/BaseAutocomplete.vue";
import { mapGetters } from "vuex";
import mixins from "@/mixins";
import { optionsCurrency, optionsPercent } from "../../utils";
const { formRules } = mixins;

export default {
  name: "GeneralSettings",
  components: {
    TopicTitle,
    BaseTextField,
    BaseSelect,
    DateTimePicker,
    BaseMoneyField,
    // BaseAutocomplete,
  },
  mixins: [formRules],
  data() {
    return {
      optionsCurrency,
      optionsPercent,
      eventStore: this.$store.state.event,
      globalStore: this.$store.state.global,
      form: null,
      percentRule: {},
    };
  },

  computed: {
    ...mapGetters([
      "getEventSettingsData",
      "isAdmin",
      "getEventType",
      "allEvents",
      "eventsLoading",
      "getEventSettingsDataCached",
      "getIsRecurringEvent",
    ]),
    cancellationPeriod() {
      return [
        {
          item: this.$t("new-event.settings.period-cancel-options.default"),
          value: "default",
        },
        {
          item: this.$t("new-event.settings.period-cancel-options.disabled"),
          value: "disabled",
        },
        {
          item: this.$t("new-event.settings.period-cancel-options.custom"),
          value: "custom",
        },
      ];
    },
    commissionType() {
      return [
        {
          item: this.$t("new-event.settings.comission-type.comission"),
          value: "COMISSAO",
        },
        {
          item: this.$t("new-event.settings.comission-type.convenience"),
          value: "CONVENIENCIA",
        },
      ];
    },
    typeTax() {
      return [
        {
          item: this.$t("new-event.settings.type-tax.percent"),
          value: "percent",
        },
        {
          item: this.$t("new-event.settings.type-tax.value"),
          value: "value",
        },
      ];
    },
    balanceSettings() {
      return [
        {
          item: this.$t("new-event.settings.balance-settings.pos-2"),
          value: {
            dias: "2",
            tipo: "pos",
            saque: "manual",
          },
        },
        {
          item: this.$t("new-event.settings.balance-settings.pre-2"),
          value: {
            dias: "2",
            tipo: "pre",
            saque: "manual",
          },
        },
        {
          item: this.$t("new-event.settings.balance-settings.pre-30"),
          value: {
            dias: "30",
            tipo: "pre",
            saque: "manual",
          },
        },
        {
          item: this.$t("new-event.settings.balance-settings.weekly"),
          value: {
            dias: "0",
            tipo: "semanal",
            saque: "manual",
          },
        },
      ];
    },
    publication() {
      return [
        {
          item: this.$t("new-event.settings.status.active"),
          value: "ATIVO",
        },
        {
          item: this.$t("new-event.settings.status.inactive"),
          value: "INATIVO",
        },
        {
          item: this.$t("new-event.settings.status.sold-out"),
          value: "ESGOTADO",
        },
        {
          item: this.$t("new-event.settings.status.draft"),
          value: "RASCUNHO",
        },
      ];
    },
  },
  methods: {
    accessPeriodStartFormattedDate(formatteddatetime) {
      this.getEventSettingsData.accessPeriodStart = formatteddatetime;
    },
    accessPeriodEndFormattedDate(formatteddatetime) {
      this.getEventSettingsData.accessPeriodEnd = formatteddatetime;
    },
    viewTypeFormattedDate(formatteddatetime) {
      this.getEventSettingsData.viewType = formatteddatetime;
    },
    limitInput(event, field) {
      let value = event.target.value.replace(/\D/g, "");
      if (value.length > 7) {
        value = value.slice(0, 7);
      }
      this.getEventSettingsData[field] = value;
    },
  },
  watch: {
    "$store.getters.getEventSettingsData.cancellationPeriod"() {
      if (this.getEventSettingsData.cancellationPeriod === "default") {
        this.getEventSettingsData.cancellationDays = 7;
        this.getEventSettingsData.cancellationHours = 24;
      } else if (this.getEventSettingsData.cancellationPeriod === "disabled") {
        this.getEventSettingsData.cancellationDays = 7;
        this.getEventSettingsData.cancellationHours = 24;
      }
    },
  },
};
</script>

<style>
.v-text-field {
  margin: unset !important;
}
</style>
